module.exports = __webpack_public_path__ + "6f79a160a49cfb0563529187ee525339.png";